import moment from 'moment';
import _ from 'lodash';

import { PhysicalEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

import * as types from './types';

const INITIAL_STATE = {
  physicalListData: [],
  physicalListDataError: null,
  loading: false,
  printLoading: false,
  printError: null,
  printData: '',
  deleteMsg: null,
  deleteErrorMsg: null,
  printLoadingError: null,
  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PHYSICAL_DATA_LIST: {
      return {
        ...state,
        physicalListData: action.payload.map(item => ({
          ...item,
          [PhysicalEnum.PhysicalDT]: [PhysicalEnum.PhysicalDT]
            ? moment(item[PhysicalEnum.PhysicalDT]).format(DATE_FORMAT_FOR_UI)
            : '',
        })),
      };
    }
    case types.PHYSICAL_DATA_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.PHYSICAL_DATA_ERROR:
      return {
        ...state,
        physicalListDataError: action.payload,
      };

    case types.PRINT_PHYSICAL_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };

    case types.PRINT_PHYSICAL_ERROR:
      return {
        ...state,
        printError: action.payload,
      };
    case types.CLEAR_PHYSICAL_ERROR:
      return {
        ...state,
        printError: null,
        deleteMsg: null,
        deleteErrorMsg: null,
        physicalListDataError: null,
        printLoadingError: null,
      };
    case types.PHYSICAL_CLEAR_GRID_DATA: {
      return {
        ...INITIAL_STATE,
        loading: false,
      };
    }
    case types.PHYSICAL_DATA_DELETE: {
      const deleteMsg = action.payload;
      if (
        _.has(deleteMsg, 'data.Data') &&
        _.has(deleteMsg, 'data.Data.Title') &&
        _.has(deleteMsg, 'data.Data.Message')
      ) {
        return {
          ...state,
          deleteMsg: deleteMsg.data.Data,
        };
      }
      return {
        ...state,
        deleteMsg: {
          Title: 'Success',
          Message: 'Physical(s) deleted successfully.',
        },
      };
    }
    case types.PHYSICAL_DATA_DELETE_ERROR:
      return {
        ...state,
        deleteErrorMsg: action.payload,
      };

    case types.CLEAR_PHYSICAL_LIST_ERROR:
      return {
        ...state,
        printLoadingError: null,
        physicalListDataError: null,
      };

    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };

    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };

    case types.SET_PRINT_DATA:
      return {
        ...state,
        printData: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/PhysicalList/reducer.js